import {
  ACTION_GET_ORG_EXPENSE_REPORTS,
  ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS,
  ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE,
  ACTION_GET_MORE_ORG_EXPENSE_REPORTS,
  ACTION_GET_MORE_ORG_EXPENSE_REPORTS_SUCCESS,
  ACTION_GET_MORE_ORG_EXPENSE_REPORTS_FAILURE,
  ACTION_EMPTY_ORG_EXPENSE_REPORTS,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export interface OrgExpenseReportsParams {
  limit?: number;
  syncToGlStatus?: string;
  dateFrom?: string;
  dateTo?: string;
}

export function getOrgExpenseReports(organizationId: string, params?: OrgExpenseReportsParams) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({ type: ACTION_GET_ORG_EXPENSE_REPORTS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/expense-reports`,
        method: 'get',
        data: params || {},
        success: (response: any) => {
          dispatch({ type: ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE, payload: error });
        },
      },
    });
  };
}

export function getMoreOrgExpenseReports(
  organizationId: string,
  params: OrgExpenseReportsParams,
  cursor: { id: string; created: string },
) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({ type: ACTION_GET_MORE_ORG_EXPENSE_REPORTS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/expense-reports`,
        method: 'get',
        data: {
          ...params,
          'cursor[id]': cursor.id,
          'cursor[created]': cursor.created,
        },
        success: (response: any) => {
          dispatch({ type: ACTION_GET_MORE_ORG_EXPENSE_REPORTS_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_MORE_ORG_EXPENSE_REPORTS_FAILURE, payload: error });
        },
      },
    });
  };
}

export const emptyOrgExpenseReports = () => ({ type: ACTION_EMPTY_ORG_EXPENSE_REPORTS, payload: null });

